import { MenuItemType } from "@multiweb/types/contracts";
import { IMainMenuItemActionParams, MainMenuItemActionData, MainMenuItemActionType } from "@multiweb/types/multiweb";
import { MenuItemActivatedType } from "../types";

/**
 * Sestaví objekt parametrů pro zpracování custom akce ze zadaného typu a dat.
 * @param itemType Typ položky.
 * @param itemData Údaje o položce.
 * @return Objekt parametrů nebo undefined, pokud jsou údaje o položce undefined.
 */
export const createMainMenuItemActionParams = (
    itemType: MainMenuItemActionType,
    itemData: MainMenuItemActionData | undefined,
): IMainMenuItemActionParams | undefined => {
    if (itemData) {
        return {
            itemType,
            itemData,
        };
    } else {
        return undefined;
    }
};

/**
 * Převede aktivační typ na typ položky menu. Slouží pro ságu pro tvorbu parametrů pro položky z kategorie formulářových položek definovaných v {@link formCompatibleItems}.
 * @param activationType
 * @throws Pro nepodporované aktivační typy vyhazuje výjimku.
 */
export const activationTypeToMenuItemType = (activationType: MenuItemActivatedType): MenuItemType => {
    switch (activationType) {
        case MenuItemActivatedType.form:
        case MenuItemActivatedType.panelItemForm:
        case MenuItemActivatedType.profile:
            return MenuItemType.form;
        case MenuItemActivatedType.formFolder:
        case MenuItemActivatedType.panelItemFormFolder:
            return MenuItemType.folder;
        case MenuItemActivatedType.panelItemCombinedItemForm:
        case MenuItemActivatedType.panelItemCombinedItemFolder:
            return MenuItemType.combined;
        default:
            throw new Error(`[MainMenu - CustomActions] Unsupported activation type for form category of menu item: ${activationType}`);
    }
};
